<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6">
        <b-card v-if="registro_no_encontrado">
          <div slot="header">
            <strong>Centro no encontrado</strong>
          </div>
        </b-card>
        <b-card no-body :no-block="true" v-else>
          <div slot="header">
            <strong>{{this.$route.params.id == null ? "Nuevo" :"Actualizar"}} Centro</strong>
          </div>
          <b-card-body>
            <b-form>
              <b-form-group>
                <label class="col-form-label" for="codigo">Código</label>
                <input
                  type="text"
                  autocomplete="off"
                  id="nombre"
                  v-model="model.codigo"
                  :class="{'form-control is-invalid': errores.codigo, 'form-control is-valid': !errores.codigo}"
                />
                <b-form-invalid-feedback v-if="errores.codigo">{{ errores.codigo }}</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group>
                <label class="col-form-label" for="nombre">Nombre</label>
                <input
                  type="text"
                  autocomplete="off"
                  id="nombre"
                  v-model="model.nombre"
                  :class="{'form-control is-invalid': errores.nombre, 'form-control is-valid': !errores.nombre}"
                />
                <b-form-invalid-feedback v-if="errores.nombre">{{ errores.nombre }}</b-form-invalid-feedback>
                <label class="col-form-label" for="area">Empresa</label>
                <b-form-select
                      v-model="model.empresa_id"
                      :options="empresas"
                      value-field="id"
                      text-field="nombre"
                      :state="!errores.empresa_id"
                    ></b-form-select>
                <span class="errorcito" v-show="errores.empresa_id">{{ errores.empresa_id }}</span>
              </b-form-group>
               <b-form-group>
                <label class="col-form-label" for="codigo">Activo</label>
                <b-form-select
                  v-model="model.activo"
                  :options="sinoList"
                ></b-form-select>
              </b-form-group>
            </b-form>
          </b-card-body>
          <div slot="footer">
            <a class="btn btn-sm btn-success text-white" @click="guardar()">
              <i class="fa fa-dot-circle-o"></i> Guardar
            </a>
            <router-link class="btn btn-sm btn-danger text-white" :to="'/centros/'">
              <i class="fa fa-ban" /> Cancelar
            </router-link>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: "CentroForm",
  data() {
    return {
      empresas: [],
      model: {},
      errores: {},
      registro_no_encontrado: null,
      ruta_guardar: '/api/catalogos/centro-store',
      sinoList:[
        { value: 0, text: 'No' },
        { value: 1, text: 'Si' },
      ]
    };
  },
  created() {
    this.cargar();
    this.getEmpresas();
  },
  methods: {
    async cargar() {
      if (this.$route.name == "Crear Centro")
        this.registro_no_encontrado = false;
      else if (this.$route.params.id != null)
        try {
          // eslint-disable-next-line no-undef
          let {data} = await axios.post("/api/catalogos/centro", {
            id: this.$route.params.id
          });
          if (!data.data) this.registro_no_encontrado = true;
          this.model = data.data;
        } catch (error) {
          console.log(error);
        }
      else this.registro_no_encontrado = true;
    },
    async guardar() {
      try {
        // eslint-disable-next-line no-undef
        let {data} = await axios.post(this.ruta_guardar, this.model);
        if (data.status == "fail") {
          this.errores = data.errors;
        } else this.$router.push("/centros");
      } catch (error) {
        console.log(error);
      }
    },
    async getEmpresas() {
      try {
        // eslint-disable-next-line no-undef
        let {data} = await axios.get("/api/catalogos/empresas-list");
        this.empresas = data.data;
        this.empresas.unshift({ id: null, nombre: "Seleccione" });
      } catch (error) {
        console.log(error);
      }
    },
 
  }
};
</script> 
<style scoped>
.errorcito{
  font-size: 80%;
  color: #f86c6b;
}
</style>